import { combineReducers } from "redux";
import snackbar from "./snackbarReducer";
import * as auth from "../containers/modules/Auth/_redux/authRedux";
import accountReducer from "../containers/Accounts/store/reducers/index";
import senderIdReducer from "../containers/SenderId/store/reducers";
import gatewayAndPriceReducer from "../containers/GatewayAndPrice/store/reducers";
import gatewayNameReducer from "../containers/GatewayName/store/reducers";
import campaignLiveStatusReducer from "../containers/campaign-live-status/store/reducers/campaign-live-status.reducers";
import campaignLiveStatusV2Reducer from "../containers/campaign-live-status-v2/store/reducers/campaign-live-status.reducers";
import transactionHistory from "../containers/Wallet-history/store/reducers/index";
import whatsAppAccountReducer from '../containers/WhatsAppAccounts/store/reducers/index'
import adminAnalyticsReducer from "../containers/AdminAnalytics/store/reducers";

export const rootReducer = combineReducers({
  snackbar,
  auth: auth.reducer,
  accounts: accountReducer,
  senderIds: senderIdReducer,
  gatewayAndPrice: gatewayAndPriceReducer,
  gatewayName: gatewayNameReducer,
  campaignLiveStatus: campaignLiveStatusReducer,
  campaignLiveStatusV2: campaignLiveStatusV2Reducer,
  walletHistory: transactionHistory,
  whatsAppAccounts: whatsAppAccountReducer,
  adminAnalytics: adminAnalyticsReducer
});

// export function* rootSaga() {
//   yield all([auth.saga()]);
// }
